import pathRegexp from 'path-to-regexp';
import numeral from 'numeral';

export const getRounding = (currcode) => {
  switch (currcode) {
    case 'EUR':
      return 2;
    case 'XOF':
      return 0;

    case 'USD':
      return 2;

    case 'MAD':
      return 2;

    case 'TND':
      return 3;

    default:
      return 2;
  }
};

export const getRouteAuthority = (path, routeData) => {
  let authorities;
  routeData.forEach((route) => {
    if (pathRegexp(`${route.path}/(.*)`).test(`${path}/`)) {
      if (route.authority) {
        authorities = route.authority;
      }

      if (route.path === path) {
        authorities = route.authority || authorities;
      }

      if (route.routes) {
        authorities = getRouteAuthority(path, route.routes) || authorities;
      }
    }
  });
  return authorities;
};

export const toCurrency = (val, currcode, hideCurrcode) => {
  let ret = `0`;

  let lcurrcode = currcode;

  if (currcode === '' || currcode == null || currcode === undefined) {
    lcurrcode = localStorage.getItem('currcode');
  }
  if (val !== 0) {
    switch (lcurrcode) {
      case 'XOF':
        ret = `${hideCurrcode ? '' : 'XOF'}  ${numeral(val).format('0,0')}`;
        break;
      case 'EUR':
        ret = `€  ${numeral(val).format('0,0.00')}`;
        break;
      case 'TND':
        ret = `TND  ${numeral(val).format('0,0.000')}`;
        break;
      case 'MAD':
        ret = `${hideCurrcode ? '' : 'MAD'}  ${numeral(val).format('0,0.00')}`;
        break;

      case 'USD':
        ret = `$  ${numeral(val).format('0,0.00')}`;
        break;

      default:
        ret = `${numeral(val).format('0,0.00')}`;
    }
  }
  return ret;
};

export const toEuro = (val) => `€ ${numeral(val).format('0,0.00')}`;
export const toRate = (val) => `${numeral(val).format('0,0.00000')}%`;
export const toPercentage = (val) => `${numeral(val).format('0,0.00')}%`;
export const toCoef = (val) => `${val?.toFixed(4)}`;
export const toEuroSimpleDisplay = (val) => `€ ${numeral(val).format('0a')}`;

export const toFormaterCurrency = (val) => {
  return new Intl.NumberFormat('en-US').format(val);
};
